
// 七天前时间：
export function toDay() {
    //获取当前日期
    let myDate = new Date();
    let nowY = myDate.getFullYear();
    let nowM = myDate.getMonth() + 1;
    let nowD = myDate.getDate();
    let endDate =
        nowY +
        "-" +
        (nowM < 10 ? "0" + nowM : nowM) +
        "-" +
        (nowD < 10 ? "0" + nowD : nowD); //当前日期
    // console.log(endDate);
    return endDate;
    // this.star = endDate;
}
export function toEnd() {
    let myDate = new Date();
    let lw = new Date(myDate - 1000 * 60 * 60 * 24 * 7); //最后一个数字7可改，7天的意思
    let lastY = lw.getFullYear();
    let lastM = lw.getMonth() + 1;
    let lastD = lw.getDate();
    let startData =
        lastY +
        "-" +
        (lastM < 10 ? "0" + lastM : lastM) +
        "-" +
        (lastD < 10 ? "0" + lastD : lastD); //三十天之前日期
    // console.log(startData);
    return startData;
    // this.end = startData;
}

// 30天起始日期：
export function toThreeDay() {
    //获取当前日期
    let myDate = new Date();
    let nowY = myDate.getFullYear();
    let nowM = myDate.getMonth() + 1;
    let nowD = myDate.getDate();
    let endDate =
        nowY +
        "-" +
        (nowM < 10 ? "0" + nowM : nowM) +
        "-" +
        (nowD < 10 ? "0" + nowD : nowD); //当前日期
    // console.log(endDate);
    return endDate;
    // this.star = endDate;
}
export function toThreeEnd() {
    let myDate = new Date();
    let lw = new Date(myDate - 1000 * 60 * 60 * 24 * 30); //最后一个数字30可改，30天的意思
    let lastY = lw.getFullYear();
    let lastM = lw.getMonth() + 1;
    let lastD = lw.getDate();
    let startData =
        lastY +
        "-" +
        (lastM < 10 ? "0" + lastM : lastM) +
        "-" +
        (lastD < 10 ? "0" + lastD : lastD); //三十天之前日期
    // console.log(startData);
    return startData;
    // this.end = startData;
}

export function getfirstDateAndlastDate(dateStr){//获取指定日期所在月份的第一天和最后一天
    let date = new Date(dateStr);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if(month > 12){
        month = 1;
        year++;
    }
    if (month < 10) {
        month = '0' + month
    }
    let monthLastDay = new Date(year, month, 0).getDate();
    let firstDate = year + '-' + month + '-' + '01';
    let lastDate = year + '-' + month + '-' + monthLastDay;
    let result={
        firstDate,
        lastDate
    }
    return result
}

// const today = new Date().toISOString().slice(0, 19).replace("T", " "); //当天日期
// // 获取三个月前的日期时间
// const threeMonthsAgo = new Date();
// threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
// const datetimeThreeMonthsAgo = threeMonthsAgo.toISOString().slice(0, 19).replace("T", " ");
// // 输出结果
// console.log("今天的日期时间：", today.split(" ")[0]);
// console.log("三个月前的日期时间：", datetimeThreeMonthsAgo.split(" ")[0]);
